var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="'+
((__t=( classes ))==null?'':_.escape(__t))+
'">\n<ul></ul>\n</div>\n';
}
return __p;
};
